(function () {
    "use strict";

    angular.module("app").controller("OrganisationDossierController", OrganisationDossierController);
    OrganisationDossierController.$inject = ["$rootScope", "$scope", "$window", "$timeout", "dossierService", "enumService", "OrganisationRemarkValidator", "controllerDecorator",];
    function OrganisationDossierController($rootScope, $scope, $window, $timeout, dossierService, enumService, OrganisationRemarkValidator, controllerDecorator) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments", "navigation", "dialog", "files"]);

        const personStatusCodes = enumService.PersonStatusCodes;
        const personActionCodes = enumService.PersonActionCodes;

        const loadingController = (function () {
            const parts = {
                // Dossier: false,
                Request: false,
                SecurityOfficers: false,
            };
            return { SetLoaded: setLoaded };

            function setLoaded(key) {
                if (!parts.hasOwnProperty(key))
                    return;

                parts[key] = true;
                if (Object.values(parts).every(value => value))
                    vm.SetLoadingState(false);
            }
        })();

        $scope.ClearanceDate = { Value: null };

        initialize();

        function initialize() {
            const parsed = vm.ParseUrl();
            $scope.action = parsed.action;
            $scope.dossierId = parsed.parameters.dossierid ?? $window.location.search.split("?")[1];

            loadDossier();
        }

        const clearanceExpirationStatus = {
            NoClearance: 0,
            ExpiringSoon: 1,
            Expired: 2,
            Valid: 3
        };

        function remarkFilterFactory(sections) {
            return function (remark) {
                return sections.includes(remark.Section);
            };
        }

        $scope.filterRemarkFunctionIdentity = remarkFilterFactory(['110']);
        $scope.filterRemarkFunctionJustification = remarkFilterFactory(['120']);

        $scope.filterPersonInvalidated = remarkFilterFactory(['140']);

        $scope.DoesItemContainSectionRemark = (item, section) => item.Remarks.some(remark => remark.Section === section);

        $scope.openKBOPublicSearch = function (kboNbr) {
            vm.Navigator.OpenKboSearchNumberInTab(kboNbr);
        };

        $scope.IsValidFvm = function (clearance) {
            if (!clearance)
                return false;

            return clearance.Details && clearance.Details.length > 0;
        };

        $scope.hasPersonClearances = function () {
            return $scope.Ivms && $scope.Ivms.length > 0;
        };

        $scope.OpenIvm = function (person) {
            vm.Navigator.OpenIvmViewOnly(person.IVMLink);
        };

        $scope.filterDetails = (item) => item.Details.length !== 0;

        $scope.request = null;

        $scope.isCurrent = (tab) => dossierService.currentTab === tab;

        $scope.$on("navigation_change", (_event, tab) => { dossierService.currentTab = tab.key; });

        $scope.ShowRenewalActiveBanner = function (dossier, request) {
            if (!dossier?.Clearances || dossier.Clearances.length == 0)
                return false;
            if (!request)
                return false;

            const status = getClearanceExpirationStatus(dossier.Clearances[0]);

            if (status === clearanceExpirationStatus.ExpiringSoon || status == clearanceExpirationStatus.Expired) {
                const fvmEndStates = ["190", "191", "200", "210", "220"];

                return request.InitialAction === 12 && !fvmEndStates.includes(request.Status);
            }

            return false;
        };

        function getClearanceExpirationStatus(clearance) {
            if (!clearance || clearance.DateValidTo == null)
                return clearanceExpirationStatus.NoClearance;

            if (habilCommon.dateUtils.isExpired(clearance.DateValidTo))
                return clearanceExpirationStatus.Expired;
            else if (habilCommon.dateUtils.isExpiring(clearance.DateValidTo, 12))
                return clearanceExpirationStatus.ExpiringSoon;

            return clearanceExpirationStatus.Valid;
        }

        function doFilterCheck(needFilter) {
            if (needFilter === $scope.dossier.filtered) {
                return;
            }
            $scope.dossier.filtered = needFilter;
            $scope.dossier.gap = 3;
            if (!needFilter) {
                $scope.dossier.itemsPerPage = 10;
                $scope.dossier.currentPage = 0;
            }
            else {
                $scope.dossier.itemsPerPage = 0;
                $scope.dossier.currentPage = 0;
            }
            $scope.dossier.pagedItems = [];
            if ($scope.dossier.itemsPerPage === 0) {
                $scope.dossier.pagedItems[0] = $scope.Employees;
                $scope.dossier.currentPage = 0;
            }
            else {
                for (let i = 0; i < $scope.Employees.length; i++) {
                    if (i % $scope.dossier.itemsPerPage === 0) {
                        $scope.dossier.pagedItems[Math.floor(i / $scope.dossier.itemsPerPage)] = [$scope.Employees[i]];
                    } else {
                        $scope.dossier.pagedItems[Math.floor(i / $scope.dossier.itemsPerPage)].push($scope.Employees[i]);
                    }
                }
            }
        }

        $scope.GetLevelDescription = function (vmLevelCode) {
            const levelCode = $scope.codeIVMLevels.find(el => el.Key === vmLevelCode);
            return levelCode ? levelCode.Value : vmLevelCode;
        };

        $scope.GetTypeDescription = function (vmTypeCode) {
            const typeCode = $scope.codeVMTypes.filter(el => el.Key === vmTypeCode);
            return typeCode ? typeCode.Value : vmTypeCode;
        };

        $scope.GetOrganisationPerson = function () {
            if ($scope.Employees)
                return;

            dossierService.searchOrganisationPerson($scope.dossierId,
                function (result) {
                    if (CheckResultReceived(result)) {
                        $scope.dossier.Organisations = result;
                        $scope.Employees = result;
                        $scope.Ivms = result.flatMap(p => p.Clearances);
                        doFilterCheck(false);
                    }
                    else {
                        vm.ShowError(result);
                    }
                },
                vm.ShowError
            );
        };

        function linkData(data) {
            $scope.request = data;
        }

        $scope.LoadFVMs = loadRequests;

        function getEmbeddedTranslation(object, key) {
            const translation = object[key + vm.Settings.locale.toUpperCase()];

            return translation ? translation : object[key + "EN"];
        }

        $scope.GetPersonActionDescription = getPersonActionDescription;
        function getPersonActionDescription(person) {
            if (!person)
                return;

            const actionDescriptions = [];

            if (person.StatusCode === personStatusCodes.UserBlock) {
                actionDescriptions.push(vm.getTranslation("Person_Remark_Remove"));

                return actionDescriptions.join(' / ');
            }

            if (person.Action) {
                const actionDescription = getEmbeddedTranslation(person.Action, "Description");

                if (person.Action.Code === personActionCodes.StartIVM) {
                    const statusCode = $rootScope.codeStatusRequestsIVMFromFVM.find(o => o.Key == person.IVMStatus);
                    if (statusCode) {
                        actionDescriptions.push(`${actionDescription} [${statusCode.Value}]`);

                        if (getNoAcknowledgmentChosenFor(person).length > 0) {
                            if (!person.IsInvitedToSignNoAcknowledgementDocument) {
                                actionDescriptions.push(vm.getTranslation("NoAcknowledgment_Title"));
                            }
                            else {
                                if (!person.HasSendNoAcknowledgeDocument) {
                                    actionDescriptions.push(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                                }
                                else {
                                    actionDescriptions.push(vm.getTranslation("NoAcknowledgementWasSigned"));
                                }
                            }
                        }
                    }
                    else {
                        actionDescriptions.push(actionDescription);
                    }
                } else if (person.Action.Code === personActionCodes.NoAcknowledgement) {
                    if (person.IsInvitedToSignNoAcknowledgementDocument) {
                        if (!person.HasSendNoAcknowledgeDocument) {
                            actionDescriptions.push(vm.getTranslation("NoAcknowledgementInvitationWasSent"));
                        } else {
                            actionDescriptions.push(vm.getTranslation("NoAcknowledgementWasSigned"));
                        }
                    }
                    else {
                        actionDescriptions.push(actionDescription);
                    }
                }
                else {
                    // Action required
                    actionDescriptions.push(actionDescription);
                }
            }

            return actionDescriptions.join(' / ');
        }

        function getNoAcknowledgmentChosenFor(person) {
            if (!person || !person.NoAcknowledgementForClearanceCodes)
                return [];

            return JSON.parse(person.NoAcknowledgementForClearanceCodes);
        }

        $scope.Filter = {};
        $scope.Filter.DossierNumber = "";
        $scope.Filter.ReferenceNumber = "";
        $scope.Filter.Name = "";
        $scope.filterEmployees = function (employee) {
            employee.collapse = true;
            let name = employee.DossierPerson.Firstname + ' ' + employee.DossierPerson.Name;
            name = name.toLowerCase();
            if ($scope.Filter.DossierNumber === "" &&
                $scope.Filter.ReferenceNumber === "" &&
                $scope.Filter.Name === "") {
                doFilterCheck(false);
                return true;
            }
            if ($scope.Filter.DossierNumber !== "" && employee.DossierPerson.DossierNbr.indexOf($scope.Filter.DossierNumber) < 0) {
                doFilterCheck(true);
                return false;
            }
            if ($scope.Filter.ReferenceNumber !== "" && employee.DossierPerson.ReferenceNbr.indexOf($scope.Filter.ReferenceNumber) < 0) {
                doFilterCheck(true);
                return false;
            }
            if ($scope.Filter.Name !== "" && name.indexOf($scope.Filter.Name.toLowerCase()) < 0) {
                doFilterCheck(true);
                return false;
            }

            return true;
        };

        $scope.prevPage = function () {
            if ($scope.dossier.currentPage > 0) {
                $scope.dossier.currentPage--;
                $scope.dossier.currentPageInt = $scope.dossier.currentPage + 1;
            }
        };

        $scope.nextPage = function () {
            if ($scope.dossier.currentPage < $scope.dossier.pagedItems.length - 1) {
                $scope.dossier.currentPage++;
                $scope.dossier.currentPageInt = $scope.dossier.currentPage + 1;
            }
        };

        $scope.lastPage = function () {
            $scope.dossier.currentPage = $scope.dossier.pagedItems.length - 1;
        };

        $scope.setPage = function () {
            if (this.n !== undefined) {
                $scope.dossier.currentPage = this.n;
                $scope.dossier.currentPageInt = $scope.dossier.currentPage + 1;
            }
            else {
                $scope.dossier.currentPage = $scope.dossier.currentPageInt - 1;
            }
        };

        $scope.range = function (size, start, end) {
            const ret = [];
            if (size < end) {
                end = size;
                start = size - $scope.dossier.gap;
            }
            if (start < 0) {
                start = 0;
            }
            for (let i = start; i < end; i++) {
                ret.push(i);
            }
            return ret;
        };

        $scope.dateWithMonthsDelay = dateWithMonthsDelay;
        function dateWithMonthsDelay(startDate, months) {
            const date = new Date(startDate);
            date.setMonth(date.getMonth() + months);
            return date;
        }

        $scope.compareDateStart = compareDateStart;
        function compareDateStart(startDate, months) {
            return dateWithMonthsDelay(startDate, months) < dateWithMonthsDelay(new Date(), 9);
        }

        $scope.compareDateStartEnd = compareDateStartEnd;
        function compareDateStartEnd(startDate, endDate) {
            return endDate <= startDate || endDate <= dateWithMonthsDelay(new Date(), 9);
        }

        /**
         * Called by ng-init to open invalidated justifications on load
         * @param {Object} justification The justification model
         * @param {Number} index The index of the justification in the request
         */
        $scope.InitializeJustificationState = function (justification, index) {
            // We NEED to use timeout to wait until after the justification is rendered
            // Without timeout we need to use ng-class to conditionally apply the in class
            // This causes issues when adding new items
            $timeout(() => setJustificationState(justification, index), 0);
        };

        //#endregion

        $scope.JustificationNeedsToBeValidated = justificationNeedsToBeValidated;
        function justificationNeedsToBeValidated(justification) {
            return !(justification.IsCopied && justification.Action === null);
        }

        function setJustificationState(justification, index) {
            if (!justificationNeedsToBeValidated(justification))
                return;

            const target = $(`#justification-${index}`);
            if (!OrganisationRemarkValidator.IsItemChecked(justification, 'justification'))
                target.collapse('show');
            else
                target.collapse('hide');
        }

        //#region "Load data"

        function loadDossier() {
            vm.SetLoadingState(true);

            vm.Api.GetOrganisationDossier(
                { DossierId: $scope.dossierId },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    $scope.dossier = result.data;

                    $scope.dossier.HasHabilPlusClearance = $scope.dossier.Clearances && $scope.dossier.Clearances.length > 0 && $scope.dossier.Clearances.some(c => c.ClearanceType === "10");

                    if ($scope.dossier.StatusCode != 50 && $scope.dossier.HasHabilPlusClearance && !$scope.dossier.IsGovernment)
                        $scope.ClearanceDate.Value = $scope.dossier.Clearances[0].DateValidTo;

                    $scope.selectedScreeningPartner = $scope.dossier.ICD;

                    loadDetails();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        };

        /**
         * Kicks of requests for loading details of the dossier
         * - Security officers
         * - Current request
         * - All requests
         * - Employees
         */
        function loadDetails() {
            loadRequest($scope.dossier.LastRequestId);

            getSecurityOfficersByDossierOrganisationId();
        }

        function loadRequest(requestId) {
            if (!requestId)
                return;

            vm.Api.GetFVMPhase2(
                { RequestId: requestId },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    linkData(result.data);

                    vm.Api.GetFvmPhase1SignaturesByUser({ FvmId: $scope.request.PublicId }, (r) => $scope.Signatures = r.data);

                    vm.Comments.Initialize({ RequestId: $scope.request.PublicId, DossierId: null, OrganisationId: $scope.dossier.PublicId, ICD: $scope.request.ScreeningBy });
                },
                vm.ShowError,
                () => loadingController.SetLoaded("Request"));
        };

        function loadRequests() {
            const filter = { DossierNumber: $scope.dossier.DossierNbr };
            vm.Api.SearchFVMRequests(
                { Filter: filter, PageAndSort: {} },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    $scope.Requests = result.data;
                },
                vm.ShowError
            );
        }

        function getSecurityOfficersByDossierOrganisationId() {
            vm.Api.GetAllSoUsersByDossierOrganisationId(
                { DossierOrganisationId: $scope.dossier.PublicId, IncludeAssistants: true },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    const data = result.data || [];

                    $scope.SecurityOfficers = data.filter(u => !u.IsAssistant);
                    $scope.Assistants = data.filter(u => u.IsAssistant);
                },
                vm.ShowError,
                () => loadingController.SetLoaded("SecurityOfficers")
            );
        }

        $scope.getPscRequestRowStyle = getPscRequestRowStyle;
        function getPscRequestRowStyle(request) {
            if (!request)
                return;

            if (request.Deleted)
                return "bg-danger";

            const states = [
                enumService.IvmStatusCodes.ConfirmStopScreening,
                enumService.IvmStatusCodes.ConfirmationGivenToStopScreening
            ];

            if (states.includes(request.Status) && request.IsReported)
                return "retour";

            if (request.IsForeign)
                return "panel-Foreign bg-Foreign";
        }

        //#endregion
    }
})();
